import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import UserAvatar from '../users/UserAvatar';
import { globalStyles as styles } from '../style/gstheme';

class UserCard extends React.Component {

  selectUser = () => this.props.onSelectUser(this.props.user.id);

  render() {

    const { classes, user, isSelected } = this.props;
    const fn = user.familyName || "";
    const gn = user.givenName || user.username;
    const title = gn + " " + fn;

    return (
      <Card data-test="user-card" className={isSelected ? classes.gsSelectedCard : classes.gsCard} onClick={this.selectUser}>
        <CardHeader
          data-test="user-fullname"
          classes={{
            root: classes.gsCardInner
          }}
          titleTypographyProps={{
            className: classes.gsCardHeader
          }}
          style={{
            ...(user.deleted && !isSelected) && { color: '#DD2C00' },
            ...(user.pendingDeletion && !isSelected) && { color: '#ff6600' }
          }}
          avatar={<UserAvatar size="small" givenName={user.givenName || ""} familyName={user.familyName || ""} />}
          title={title}
        />
      </Card>
    );
  }
}

UserCard.propTypes = {
  isSelected: PropTypes.bool,
  user: PropTypes.object.isRequired,
  classes: PropTypes.object,
  onSelectUser: PropTypes.func.isRequired
};

export default withStyles(styles)(UserCard);